export default __webpack_public_path__ + "static/media/WifiIcon.26a59915.svg";